import { render, staticRenderFns } from "./OirsView.vue?vue&type=template&id=5901cf01&"
import script from "./OirsView.vue?vue&type=script&lang=ts&"
export * from "./OirsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports